import React from 'react';
import Fab from '@mui/material/Fab';
import Slide from '@mui/material/Slide';
import SmsIcon from '@mui/icons-material/Sms';
import CloseIcon from '@mui/icons-material/Close';
import { Zoom } from '@mui/material';
import 'react-chat-elements/dist/main.css'
import TokenService from '../../services/TokenService';
import { useSnackbar } from 'notistack';
import './Chatbox.css';
import CircularProgress from '@mui/material/CircularProgress';
import { MessageBox, MessageList, ChatItem, Input, Avatar } from 'react-chat-elements' // https://www.npmjs.com/package/react-chat-elements
import Badge from '@mui/material/Badge';

import {
    TextField,
    InputAdornment,
    Button,
    Drawer
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

export default function ChatBox(props) {

    const [isShown, setIsShown] = React.useState(false);
    const [floatingButton, setFloatingButton] = React.useState(props.FloatingButton === undefined ? true : props.FloatingButton);
    const [messageToSend, setMessageToSend] = React.useState('');
    const [isSending, setIsSending] = React.useState(false);
    const [unreadCount, setUnreadCount] = React.useState(0);
    const scrollpanelRef = React.useRef(null);
    const [snackbar, setSnackbar] = React.useState({
        message: '',
        severity: 'info'
    });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    function preventBodyScroll() {
        if (isShown) {
            document.body.classList.add("no-scroll");
        }
        else {
            document.body.classList.remove("no-scroll");
        }
    }

    React.useEffect(() => {
        //console.log('isShown = ' + isShown);
        if (isShown) {
            // scroll to bottom of panel
            //scrollpanelRef.current
            window.setTimeout(function () {
                if (scrollpanelRef.current !== null) {
                    scrollpanelRef.current.scrollTop = scrollpanelRef.current.scrollHeight;
                }
            }, 200)

        }
    }, [isShown]);

    React.useEffect(() => {

        // console.log('props changed');
        // scroll to bottom of panel
        window.setTimeout(function () {
            if (scrollpanelRef.current !== null) {
                scrollpanelRef.current.scrollTop = scrollpanelRef.current.scrollHeight;
            }
        }, 200);

        setUnreadCount(unreadMessageCount());

    }, [props]);

    function buildChatMessages() {
        if (props.order.ChatMessages !== undefined) {
            let messages = [];

            for (let i = 0; i < props.order.ChatMessages.length; i++) {
                if (typeof props.order.ChatMessages[i] === 'string') {
                    props.order.ChatMessages[i] = JSON.parse(props.order.ChatMessages[i]);
                }
                let avatar = '';
                let position = 'right';
                if (props.loggedInUser === undefined) {
                    // customer viewing
                    if (props.order.ChatMessages[i].SenderType === 'recycler') {
                        avatar = props.order.ChatMessages[i].AvatarUrl;
                        position = props.recipient === props.order.ChatMessages[i].SenderType ? 'right' : 'left';
                    }
                    else if (props.order.ChatMessages[i].SenderType === 'admin') {
                        avatar = 'images/SipzeeAvatar.png'
                        position = 'left';
                    }
                }
                else {
                    // customer viewing
                    if (props.order.ChatMessages[i].SenderType === 'customer') {
                        avatar = 'images/CustomerChatAvatar.png'
                        position = props.recipient === props.order.ChatMessages[i].SenderType ? 'right' : 'left';
                    }
                    else if (props.order.ChatMessages[i].SenderType === 'admin') {
                        avatar = 'images/SipzeeAvatar.png'
                        position = 'left';
                    }
                }

                messages.push(
                    <MessageBox
                        key={props.order.OrderGUID + '_' + i}
                        position={position}
                        type={"text"}
                        title={props.order.ChatMessages[i].SenderName}
                        text={props.order.ChatMessages[i].Message}
                        date={convertLocalDateToUTCDate(new Date(props.order.ChatMessages[i].SentTimestampUTC), false)}
                        avatar={avatar}
                    />
                )
            }
            return messages;
        }
        return null;
    }

    //Covert datetime by GMT offset 
    //If toUTC is true then return UTC time other wise return local time
    function convertLocalDateToUTCDate(date, toUTC) {
        date = new Date(date);
        //Local time converted to UTC
        // console.log("Time: " + date);
        var localOffset = date.getTimezoneOffset() * 60000;
        var localTime = date.getTime();
        if (toUTC) {
            date = localTime + localOffset;
        } else {
            date = localTime - localOffset;
        }
        date = new Date(date);
        //console.log("Converted time: " + date);
        return date;
    }

    function unreadMessageCount() {
        if (props.loggedInUser !== undefined) {
            if (isShown) {
                return 0; // assume all messages are now viewed
            }
            let count = 0;
            for (let i = 0; i < props.order.ChatMessages.length; i++) {
                if (props.order.ChatMessages[i].ViewedByRecyclerUTC == '0001-01-01T00:00:00' && props.recipient !== props.order.ChatMessages[i].SenderType) {
                    count++;
                }
            }
            return count;
        }

        return 0;
    }

    function handleSendMessage() {
        if (messageToSend.trim() !== '') {
            let clientType = '';
            
            if (props.loggedInUser === undefined || props.loggedInUser === null) {
                clientType = props.recipient;
            }
            else if (props.loggedInUser.UserAccess.includes('ADMIN') && props.recipient == 'admin') {
                clientType = 'admin'; // occurs when viewing from the Admin panel
            }
            else if (props.loggedInUser.EmailAddress.toLowerCase() === props.order.Owner.toLowerCase()) {
                clientType = 'recycler'
            }
            else {
                // check if use is an Admin
                if (props.loggedInUser.UserAccess.includes('ADMIN')) {
                    clientType = 'admin'
                }
                else {
                    return;
                }
            }

            setIsSending(true);

            let postData = {
                clientType: clientType,
                message: messageToSend.trim(),
                orderGuid: props.order.OrderGUID
            }

            TokenService.orderServicePost(postData, 'SendChatMessage')
                .then((response) => {
                    setIsSending(false);
                    response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {
                        let jsonData = JSON.parse(response.JsonData);
                        let chatMessage = JSON.parse(jsonData.Message);
                        /*props.order.ChatMessages.push(jsonData);*/
                        props.onMessageAdded(chatMessage, props.order);
                    }
                })
                .catch((response) => {
                    setIsSending(false);
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                });

        }
        setMessageToSend('');
    }

    function toggleShow() {

        if (!isShown) {
            // opening
            props.messagesViewed(props.order);
            setUnreadCount(0);
        }

        setIsShown(!isShown);
    }

    preventBodyScroll();


    return (
        <>
            <Drawer anchor="right" open={isShown}
                className={(floatingButton ? 'FloatingBoxWithButton' : 'FloatingBoxNoButton') + ' ChatDrawer'}
                style={{ backgroundColor: 'transparent', boxShadow: 'none' }}
            >
                <div className={'ChatPanel'} >
                    {floatingButton ? null :
                        <Fab color='primary' className={'FloatingBoxCloseButton'} onClick={() => toggleShow()} sx={{ color: '#ffffff', border: '2px solid var(--sipzee-gray-2)' }}>
                            <CloseIcon />
                        </Fab>
                    }
                    <div className={'ChatHeader'}>
                        {props.recipient == 'admin' ? 
                            <div>Chat as <span style={{ fontWeight: 'bold' }}> Sipzee</span></div>
                            :
                            <div>Chat with <span style={{ fontWeight: 'bold' }}> {props.order.CustomerName}</span></div>
                        }
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignSelf: 'stretch', flex: 1, overflow: 'hidden' }}>
                        <div className={'ChatScrollPanel'} ref={scrollpanelRef}>
                            {buildChatMessages()}
                        </div>
                        <div style={{ display: 'flex' }}>
                            <TextField multiline label="Send a message..." variant="filled" style={{ backgroundColor: 'white', flex: 1 }}
                                value={messageToSend} onChange={(e) => setMessageToSend(e.target.value)}


                            />
                            <Fab disabled={isSending} onClick={() => handleSendMessage()} sx={{ backgroundColor: 'var(--sipzee-green)' }}>
                                {isSending ?
                                    <CircularProgress size={20} color="success" />
                                    :

                                    <SendIcon />
                                }
                            </Fab>
                        </div>
                    </div>

                </div>
            </Drawer>

            <div className={floatingButton ? 'FloatingButton' : ''}>
                <Badge badgeContent={unreadCount}
                    color="sipzeeRed"
                    overlap="circular"
                    sx={{ zIndex: 1051 }}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <Fab color='primary' onClick={() => toggleShow()} sx={{ color: '#ffffff' }}>
                        {floatingButton ?
                            <>
                                <Zoom in={!isShown} style={{ position: 'absolute' }}>
                                    <SmsIcon />
                                </Zoom>
                                <Zoom in={isShown} style={{ position: 'absolute' }}>
                                    <CloseIcon />
                                </Zoom>

                            </>
                            :
                            <SmsIcon />
                        }

                    </Fab>
                </Badge>
            </div>
        </>
    );
}

